<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                @click="$router.go(-1)"
                flat
                color="transparent"
                style="width: 20%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="28"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="amanata"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-3"
                    style="font-weight: 600;">
                    Detail Gaji Bulanan
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card v-if="process.load && Object.keys(detail).length < 1"
                flat
                min-height="calc(100vh - 180px)"
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text>
                  <div
                    class="d-flex align-center">
                    <div>
                      <v-img
                        contain
                        width="75"
                        height="75"
                        alt="amanata" 
                        :src="Object.keys(company).length > 0 ? company.fav_icon : require('@/assets/logo/favicon.png')"
                        class="ma-auto"
                        style="border-radius: 10px;">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </div>

                    <v-spacer />

                    <div
                      class="black--text text-right">
                      <!-- <div
                        class="title font-weight-bold line-text-first">
                        Amanata
                      </div>

                      <div
                        class="body-2 font-weight-bold line-text-first">
                        Sleman Kota, Yogyakarta 55281
                      </div>

                      <div
                        class="body-2 font-weight-bold line-text-first">
                        +62811256599 | info@amanata.co
                      </div> -->
                      <div
                        class="title font-weight-bold line-text-first">
                        PT Karya Unggul Berkemajuan
                      </div>

                      <div
                        class="body-2 font-weight-bold line-text-first">
                        Ngebel – Tamantirto Kasihan Bantul DIY
                      </div>

                      <div
                        class="body-2 font-weight-bold line-text-first">
                        (+62) 821-2512-4690 | 0274 – 4299322 | karyaunggulberkemajuan@gmail.com
                      </div>
                    </div>
                  </div>

                  <v-card
                    flat
                    :color="set_color"
                    class="mt-6"
                    style="border-radius: 8px;">
                    <v-card-text
                      class="d-flex align-center white--text font-weight-bold">
                      <div>
                        PAYSLIP
                      </div>

                      <v-spacer />

                      <div
                        class="text-uppercase">
                        PERIODE {{ periode_now }}
                      </div>
                    </v-card-text>
                  </v-card>
                </v-card-text>
                
                <v-card-text>
                  <v-skeleton-loader
                    class="ma-auto"
                    :loading="process.load"
                    type="article, list-item-three-line, table">
                  </v-skeleton-loader>
                </v-card-text>
              </v-card>

              <v-card v-if="!process.load && Object.keys(detail).length > 0"
                flat
                min-height="calc(100vh - 180px)"
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <div
                  ref="sallarypdf">
                  <v-card-text
                    class="pb-0"
                    style="padding-bottom: 0px !important;">
                    <div
                      class="d-flex align-center"
                      style="display: flex !important; align-items: center !important; justify-content: space-between !important; width: 100% !important;">
                      <div>
                        <!-- <v-img
                          id="company_logo"
                          contain
                          width="175"
                          height="75"
                          alt="amanata" 
                          :src="Object.keys(detail).length > 0 ? detail.company_logo_image_base64 : require('@/assets/logo/favicon.png')"
                          class="ma-auto"
                          style="border-radius: 10px;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img> -->
                        <v-img
                          id="company_logo"
                          contain
                          width="175"
                          height="75"
                          alt="amanata" 
                          :src="require('@/assets/logo/favicon.png')"
                          class="ma-auto"
                          style="border-radius: 10px;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>

                      <div style="flex: 1 !important;"></div>

                      <div
                        class="black--text text-right"
                        style="text-align: right !important; margin-left: auto !important;">
                        <div
                          class="title font-weight-bold line-text-first"
                          style="font-weight: bold !important; font-size: 1.25rem !important; text-align: right !important;">
                          {{ detail.company_name }}
                          <!-- PT Karya Unggul Berkemajuan -->
                        </div>

                        <div
                          class="body-2 font-weight-bold line-text-first"
                          style="font-weight: bold !important; text-align: right !important;">
                          {{ detail.company_address }}
                          <!-- Ngebel – Tamantirto Kasihan Bantul DIY -->
                        </div>

                        <!-- <div
                          class="body-2 font-weight-bold line-text-first"
                          style="font-weight: bold !important; text-align: right !important;">
                          {{ detail.company_subdistrict_name }}, {{ detail.company_city_name }}, {{ detail.company_province_name }}
                        </div> -->

                        <div
                          class="body-2 font-weight-bold line-text-first"
                          style="font-weight: bold !important; text-align: right !important;">
                          <!-- {{ detail.company_pic_user_mobilephone }} | {{ detail.company_pic_user_email }} -->
                          (+62) 821-2512-4690 | 0274 – 4299322 | karyaunggulberkemajuan@gmail.com
                        </div>

                        <!-- <div
                          class="body-2 font-weight-bold line-text-first"
                          style="font-weight: bold !important;">
                          {{ detail.unit_name }}
                        </div> -->
                      </div>
                    </div>

                    <v-card
                      flat
                      :color="set_color"
                      class="mt-6"
                      style="border-radius: 8px; margin-top: 24px !important;">
                      <v-card-text
                        class="d-flex align-center"
                        style="color: white; font-weight: bold; display: flex !important; align-items: center !important;"
                        :style="process.export ? 'padding-top: 12px !important; padding-bottom: 12px !important' : ''">
                        <div>
                          PAYSLIP
                        </div>

                        <v-spacer />

                        <div
                          class="text-uppercase"
                          style="text-transform: uppercase !important;">
                          PERIODE {{ detail.end_date | month_year }}
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-card-text>

                  <v-card-text
                    class="px-8 py-0"
                    style="padding-top: 0px !important; padding-bottom: 0px !important;">
                    <v-row>
                      <v-col
                        cols="12"
                        md="6">
                        <v-row>
                          <v-col
                            cols="12"
                            md="6">
                            <div
                              class="d-flex align-start mb-2"
                              style="display: flex !important; align-items: start !important; margin-bottom: 8px !important;">
                              <div>
                                Payroll Cut-Off
                              </div>

                              <v-spacer />

                              <div>
                                :
                              </div>
                            </div>

                            <div
                              class="d-flex align-start mb-2"
                              style="display: flex !important; align-items: start !important; margin-bottom: 8px !important;">
                              <div>
                                Hari Kerja Efektif
                              </div>

                              <v-spacer />

                              <div>
                                :
                              </div>
                            </div>

                            <div
                              class="d-flex align-start mb-2"
                              style="display: flex !important; align-items: start !important; margin-bottom: 8px !important;">
                              <div>
                                Jam Kerja Lembur Biasa
                              </div>

                              <v-spacer />

                              <div>
                                :
                              </div>
                            </div>

                            <div
                              class="d-flex align-start mb-2"
                              style="display: flex !important; align-items: start !important; margin-bottom: 8px !important;">
                              <div>
                                Jam Kerja Lembur Libur
                              </div>

                              <v-spacer />

                              <div>
                                :
                              </div>
                            </div>

                            <div
                              class="d-flex align-start mb-2"
                              style="display: flex !important; align-items: start !important; margin-bottom: 8px !important;">
                              <div>
                                Nomor Induk Pegawai
                              </div>

                              <v-spacer />

                              <div>
                                :
                              </div>
                            </div>

                            <div
                              class="d-flex align-start mb-2"
                              style="display: flex !important; align-items: start !important; margin-bottom: 8px !important;">
                              <div>
                                Nama Karyawan
                              </div>

                              <v-spacer />

                              <div>
                                :
                              </div>
                            </div>
                            
                            <div
                              class="d-flex align-start"
                              style="display: flex !important; align-items: start !important;">
                              <div>
                                Unit / Divisi
                              </div>

                              <v-spacer />

                              <div>
                                :
                              </div>
                            </div>
                          </v-col>

                          <v-col
                            cols="12"
                            md="6">
                            <div
                              class="mb-2"
                              style="margin-bottom: 8px !important;">
                              {{ detail.start_date | date_month }} - {{ detail.end_date | fulldate }}
                            </div>

                            <div
                              class="mb-2"
                              style="margin-bottom: 8px !important;">
                              {{ displayInfo(detail.hari_efektif) }}
                            </div>

                            <div
                              class="mb-2"
                              style="margin-bottom: 8px !important;">
                              {{ displayInfo(detail.jam_kerja_lembur_biasa) }}
                            </div>

                            <div
                              class="mb-2"
                              style="margin-bottom: 8px !important;">
                              {{ displayInfo(detail.jam_kerja_lembur_libur) }}
                            </div>

                            <div
                              class="mb-2"
                              style="margin-bottom: 8px !important;">
                              {{ detail.user_code }}
                            </div>

                            <div
                              class="mb-2"
                              style="margin-bottom: 8px !important;">
                              {{ detail.user_name }}
                            </div>

                            <div>
                              {{ detail.unit_name }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>

                      <v-col
                        cols="12"
                        md="6">
                        <v-row>
                          <v-col
                            cols="12"
                            md="6">
                            <div
                              class="d-flex align-start mb-2"
                              style="display: flex !important; align-items: start !important; margin-bottom: 8px !important;">
                              <div>
                                Jabatan
                              </div>

                              <v-spacer />

                              <div>
                                :
                              </div>
                            </div>

                            <div
                              class="d-flex align-start mb-2"
                              style="display: flex !important; align-items: start !important; margin-bottom: 8px !important;">
                              <div>
                                Level
                              </div>

                              <v-spacer />

                              <div>
                                :
                              </div>
                            </div>

                            <div
                              class="d-flex align-start mb-2"
                              style="display: flex !important; align-items: start !important; margin-bottom: 8px !important;">
                              <div>
                                NPWP
                              </div>

                              <v-spacer />

                              <div>
                                :
                              </div>
                            </div>
                            
                            <!-- <div
                              class="d-flex align-center">
                              <div>
                                Status
                              </div>

                              <v-spacer />

                              <div>
                                :
                              </div>
                            </div> -->
                          </v-col>

                          <v-col
                            cols="12"
                            md="6">
                            <div
                              class="mb-2"
                              style="margin-bottom: 8px !important;">
                              {{ detail.user_position }}
                            </div>

                            <div
                              class="text-capitalize mb-2"
                              style="margin-bottom: 8px !important;">
                              {{ detail.user_role !== '' ? detail.user_role : '-' }}
                            </div>

                            <div
                              class="mb-2"
                              style="margin-bottom: 8px !important;">
                              {{ detail.user_npwp !== '' ? detail.user_npwp : '-' }}
                            </div>

                            <!-- <div>
                              -
                            </div> -->
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-divider
                    class="mx-5 mb-4"
                    style="border-top: 1px solid black; margin-right: 20px !important; margin-left: 20px !important; margin-bottom: 16px !important;" />

                  <v-card-text
                    class="px-8 py-0"
                    style="padding-top: 0px !important; padding-bottom: 0px !important;">
                    <v-row>
                      <v-col
                        cols="12"
                        md="12"
                        class="pl-0">
                        <v-card
                          flat
                          color="#f0f0f0"
                          class="mb-5"
                          style="border-radius: 8px; margin-bottom: 20px !important;">
                          <v-card-text
                            class="text-capitalize black--text"
                            style="font-weight: 600; text-transform: capitalize !important;">
                            income
                          </v-card-text>
                        </v-card>

                        <div>
                          <v-row
                            v-for="item in visibleIncomeItems()"
                            :key="item.field"
                            class="px-4">
                            <v-col
                              cols="12"
                              md="6"
                              class="pt-1 pb-0"
                              style="padding-top: 4px !important; padding-bottom: 0px !important;">
                              <div
                                class="d-flex align-start mb-2"
                                style="display: flex !important; align-items: start !important; margin-bottom: 8px !important;">
                                <div>
                                  {{ item.label }}
                                </div>

                                <!-- <v-spacer />

                                <div>
                                  :
                                </div> -->
                              </div>
                            </v-col>

                            <v-col
                              cols="12"
                              md="6"
                              class="pt-1 pb-0"
                              style="padding-top: 4px !important; padding-bottom: 0px !important;">
                              <div
                                class="mb-2"
                                style="margin-bottom: 8px !important; text-align: right;">
                                {{ detailNominal(item.field) | price }}
                              </div>
                            </v-col>
                          </v-row>
                        </div>
                      </v-col>

                      <!-- <v-col
                        cols="12"
                        md="6"
                        class="pr-0">
                        <v-card
                          flat
                          color="#f0f0f0"
                          class="mb-5"
                          style="border-radius: 8px; margin-bottom: 20px !important;">
                          <v-card-text
                            class="text-capitalize black--text"
                            style="font-weight: 600; text-transform: capitalize !important;">
                            deduction
                          </v-card-text>
                        </v-card>

                        <div>
                          <v-row
                            v-for="item in deductionItems()"
                            :key="item.field"
                            class="px-4">
                            <v-col
                              cols="12"
                              md="6"
                              class="pt-1 pb-0"
                              style="padding-top: 4px !important; padding-bottom: 0px !important;">
                              <div
                                class="d-flex align-start mb-2"
                                style="display: flex !important; align-items: start !important; margin-bottom: 8px !important;">
                                <div>
                                  {{ item.label }}
                                </div>

                                <v-spacer />

                                <div>
                                  :
                                </div>
                              </div>
                            </v-col>

                            <v-col
                              cols="12"
                              md="6"
                              class="pt-1 pb-0"
                              style="padding-top: 4px !important; padding-bottom: 0px !important;">
                              <div
                                class="mb-2"
                                style="margin-bottom: 8px !important;">
                                {{ detailNominal(item.field) | price }}
                              </div>
                            </v-col>
                          </v-row>
                        </div>
                      </v-col> -->
                    </v-row>

                    <v-row>
                      <v-col
                        cols="12"
                        md="12"
                        class="pl-0">
                        <v-card
                          flat
                          :color="set_color_rgb_down"
                          style="border-radius: 10px;">
                          <v-card-text
                            class="py-0"
                            style="padding-top: 0px !important; padding-bottom: 0px !important;">
                            <v-row
                              align="center">
                              <v-col
                                cols="12"
                                md="6">
                                <div
                                  class="body-1 black--text text-uppercase"
                                  style="font-weight: 500; text-transform: uppercase !important;">
                                  Total income
                                </div>
                              </v-col>

                              <v-col
                                cols="12"
                                md="6">
                                <div
                                  class="title black--text font-weight-bold text-right"
                                  style="font-weight: bold; text-align: right;">
                                  {{ totalIncome() | price }}
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>

                      <!-- <v-col
                        cols="12"
                        md="6"
                        class="pr-0">
                        <v-card
                          flat
                          :color="set_color_rgb_down"
                          style="border-radius: 10px;">
                          <v-card-text
                            class="py-0"
                            style="padding-top: 0px !important; padding-bottom: 0px !important;">
                            <v-row
                              align="center">
                              <v-col
                                cols="12"
                                md="6">
                                <div
                                  class="body-1 black--text text-uppercase"
                                  style="font-weight: 500; text-transform: uppercase !important;">
                                  Total deduction
                                </div>
                              </v-col>

                              <v-col
                                cols="12"
                                md="6">
                                <div
                                  class="title black--text font-weight-bold text-right"
                                  style="font-weight: bold; text-align: right;">
                                  {{ totalDeduction() | price }}
                                </div>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col> -->
                    </v-row>
                  </v-card-text>

                  <v-card-text
                    class="px-5 mb-2">
                    <v-card
                      flat
                      :color="set_color"
                      style="border-radius: 10px;">
                      <v-card-text
                        class="py-0"
                        style="padding-top: 0px !important; padding-bottom: 0px !important;">
                        <v-row
                          align="center">
                          <v-col
                            cols="12"
                            md="6">
                            <div
                              class="body-1 white--text text-uppercase"
                              style="color: white; font-weight: 500; text-transform: uppercase !important;">
                              Total Take Home Pay
                            </div>
                          </v-col>

                          <v-col
                            cols="12"
                            md="6"
                            class="pl-1">
                            <div
                              class="title white--text font-weight-bold text-right"
                              style="color: white; font-weight: bold; text-align: right;">
                              {{ total_sallary() | price }}
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-card-text>
                </div>

                <v-card-actions
                  class="px-4 pt-0 pb-5">
                  <v-spacer/>

                  <v-btn 
                    @click="exportToPDF()"
                    :loading="process.export"
                    :disabled="process.export"

                    color="#444444"
                    elevation="0"
                    class="body-2 white--text text-capitalize d-flex align-center"
                    style="border-radius: 10px; font-weight: 600;">
                    <v-icon size="20">mdi-cloud-print-outline</v-icon>

                    <span
                      class="ml-2">
                      Print Slip
                    </span>
                  </v-btn>
                  
                  <!-- <v-btn 
                    :disabled="process.export"
                    color="#444444"
                    elevation="0"
                    class="body-2 white--text text-capitalize d-flex align-center"
                    style="border-radius: 10px; font-weight: 600;">
                    <v-icon size="20">mdi-cloud-upload-outline</v-icon>

                    <span
                      class="ml-2">
                      Upload Slip
                    </span>
                  </v-btn> -->
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  import html2pdf from 'html2pdf.js'
  export default {
    data () {
      return {
        periode_now: moment().format('MMMM YYYY'),

        detail: {},
        detailId: {},
        
        process: {
          load: false,

          export: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      
    },
    computed: {
      company () {
        return this.$store.state.company
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true

        let params = {
          id: this.$route.params.id
        }

        await get(`admin/user_sallary/detail`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.detail = res.results.data
            this.fetchDetailUser(this.detail.user_id)
          }
        })
      },
      async fetchDetailUser (userId) {
        let params = {
          id: userId
        }

        await get('admin/user/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.detailId = res.results.data

          this.process.load = false
          }
        })
      },

      incomeItems () {
        return [
          { label: 'Gaji Pokok', field: 'gaji_pokok' },
          { label: 'Tunjangan Makan', field: 'tunj_makan' },
          { label: 'Tunjangan Transport', field: 'tunj_transport' },
          { label: 'Tunjangan Komunikasi', field: 'tunj_komunikasi' },
          { label: 'Tunjangan Fungsional', field: 'tunj_fungsional' },
          { label: 'Tunjangan Keahlian', field: 'tunj_keahlian' },
          { label: 'Tunjangan Daerah', field: 'tunj_daerah' },
          { label: 'Tunjangan Lain-lain', field: 'tunj_lain_lain' },
          { label: 'Lembur Biasa', field: 'nominal_lembur_biasa' },
          { label: 'Lembur Libur', field: 'nominal_lembur_libur' }
        ]
      },

      visibleIncomeItems () {
        return this.incomeItems().filter(item => item.field === 'gaji_pokok' || !this.isZeroNominal(item.field))
      },

      deductionItems () {
        return [
          { label: 'PPH21', field: 'pph21' },
          // { label: 'BPJS Ketenagakerjaan', field: 'bpjs_ketenagakerjaan' },
          // { label: 'BPJS Kesehatan', field: 'bpjs_kesehatan' },
          // { label: 'Potongan lain', field: 'potongan_lain' }
        ]
      },

      detailNominal (field) {
        return Number(String(this.detail[field]).replace(',', '.')) || 0
      },

      isZeroNominal (field) {
        return this.detailNominal(field) === 0
      },

      totalIncome () {
        return this.incomeItems().reduce((total, item) => total + this.detailNominal(item.field), 0)
      },

      totalDeduction () {
        return this.deductionItems().reduce((total, item) => total + this.detailNominal(item.field), 0)
      },

      total_sallary () {
        return this.totalIncome() - this.totalDeduction()
      },

      displayInfo (value) {
        return value !== null && value !== undefined && value !== '' ? value : '-'
      },

      to_blob (source) {
        // let url = ''

        // fetch(img)
        // .then(response => response.blob())
        // .then(blob => {
        //   url = URL.createObjectURL(blob)
        // })
        
        // return source

        // return axios
        // .get(source, {
        //   responseType: 'arraybuffer'
        // })
        // .then(response => Buffer.from(response.data, 'binary').toString('base64'))
      },

      exportToPDF () {
        this.process.export = true

        let filename = `Slip Gaji ${this.detail.user_name} periode ${this.detail.start_date} - ${this.detail.end_date}.pdf`

        html2pdf(this.$refs.sallarypdf, {
          margin: 0.2,
          filename: filename,
          image: { 
            type: 'jpeg', 
            quality: 0.98
          },
          html2canvas: { 
            dpi: 192, 
            letterRendering: true,
            useCORS: true
          },
          jsPDF: { 
            unit: 'in', 
            format: 'letter', 
            orientation: 'portrait'
          }
        })

        setTimeout(() => { 
          this.process.export = false
        }, 1000)
      }
    }
  }
</script>